import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Alert } from '../../models/common-model-interface';

@Component({
  selector: 'gn-alert-item',
  templateUrl: './alert-item.component.html',
  styleUrls: ['./alert-item.component.scss']
})
export class AlertItemComponent implements OnInit {
  @Input() alert: Alert
  @Output() dismissClicked: EventEmitter<Alert> = new EventEmitter<Alert>()
  @Input() alertsUrl: string;

  constructor() { }

  ngOnInit(): void {
  }

  markRead(alertMesage: any): void {

    if (alertMesage) {
      alertMesage.className += ' dismissed';
    }

    setTimeout(() => {
      this.dismissClicked.emit(this.alert);
    }, 600)
  }

}
